import { createClient } from '@map/shared';

let onUnauthorizedHook: (() => void) | undefined;

export const api = createClient({
  baseUrl: '/api',
  onUnauthorized: () => notifyUnauthorized(),
});

/** MAP-032: the shell registers here so a 401 anywhere freezes the app rather than losing work. */
export function setUnauthorizedHandler(fn: () => void): void {
  onUnauthorizedHook = fn;
}

/** Fires the registered handler; the client calls this on any 401. */
export function notifyUnauthorized(): void {
  onUnauthorizedHook?.();
}
